<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': itemPerPageOptions}"
    :search="search"
    :hide-default-header="true"
    :custom-filter="customFilter"
    no-results-text="查無符合資料"
    class="elevation-1 table-fixed"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
            :style="{'cursor': header.sortKey ? 'pointer':'initial'}"
            @click="toggleSort(header)"
          >
            <span>{{ header.text }}</span>
            <v-chip
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0"
              x-small
              style="width: 16px;padding: 0 4px;"
            >{{sorting[header.sortKey].index}}</v-chip>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'desc'"
              x-small
            >mdi-arrow-down</v-icon>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'asc'"
              x-small
            >mdi-arrow-up</v-icon>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="搜尋工作內容"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>


        <v-tooltip
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              dark
              class="mb-2 ml-1 mr-1"
              small
              @click.stop="isShowFilterDialog = true"
            >
              <v-badge color="primary" v-if="filterConditionCount > 0">
                <template v-slot:badge><span primary>{{filterConditionCount}}</span></template>
                <v-icon x-small>mdi-filter-menu</v-icon>
              </v-badge>
              <v-icon v-else x-small>mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <span>進階篩選</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-switch
          v-show="myLevel >= 10"
          style="margin-top: 16px;"
          v-model="isPaginationAllEnabled"
          label="檢視全部"
        ></v-switch>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          :disabled="isExporting"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-tooltip
          top
          v-if="myLevel >= 10"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click.stop="isShowDialog = true;editingId=-1"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </span>
          </template>
          <span>指派工作</span>
        </v-tooltip>

        <v-tooltip
          top
          v-if="myLevel == 1"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click.stop="isShowDialog = true;editingId=-1"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </span>
          </template>
          <span>新增工作</span>
        </v-tooltip>

        <task-working-item-addedit-dialog
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
        />
        <work-log-filter-dialog
          v-model="isShowFilterDialog"
          :filter-condition="filterCondition"
          @updated="onFilterUpdated"
        />

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <work-log-list-item
        :key="`item-${item.ID}`"
        :item="item"
        @edit="showEditDialog"
        @remove="deleteItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>

        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>

  <excel-export-progress-dialog
    :show="exportProgress.show"
    :phase="exportProgress.phase"
    :current="exportProgress.current"
    :total="exportProgress.total"
    :error="exportProgress.error"
    @close="closeExportProgress"
  />
</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import TaskWorkingItemAddeditDialog from "@/ui/project/task/task-working-item-addedit-dialog.vue";
import WorkLogFilterDialog from "./work-log-filter-dialog.vue";
import WorkLogListItem from "./work-log-list-item.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
import XMLGenerator from "@/data/excel/xml-generator-worklog.js";
import ExcelExportProgressDialog from "@/ui/components/excel-export-progress-dialog.vue";
import mixinExcelExportWithProgress from "@/ui/mixin-excel-export-with-progress.vue";
// filter
import advanceFilterMixin from "@/utils/mixin-vuetify-datatable-filter.vue";
// sorting
import sortingMixin from "@/utils/mixin-vuetify-datatable-sorting.vue";

import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin, advanceFilterMixin, sortingMixin, mixinDelaySearch, mixinExcelExportWithProgress],
  components: {
    TaskWorkingItemAddeditDialog,
    WorkLogListItem,
    WorkLogFilterDialog,
    ExcelExportProgressDialog,
  },
  data: () => ({
    isPaginationAllEnabled: false,
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "工作日誌",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // addedit
    isShowDialog: false,
    editingId: -1,
    // sorting
    sorting: {
      date: {
        order: "desc",
        index: 1
      },
      user: {
        order: null,
        index: -1
      },
      project: {
        order: null,
        index: -1
      }
    },
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    itemPerPageOptions () {
      return this.isPaginationAllEnabled ? [5, 10, 100, -1] : [5, 10, 100]
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    headers() {
      let actionHeader = {
        text: "操作",
        value: "action",
        showInMobile: true
      };
      return [
        {
          text: "工作日期",
          value: "_",
          sortKey: "date",
          showInMobile: true
        },
        { text: "星期", value: "_" },
        { text: "部門", value: "_" },
        { text: "人員", value: "_", sortKey: "user" },
        { text: "專案", value: "_", sortKey: "project" },
        { text: "任務", value: "_" },
        { text: "工作內容", value: "_", showInMobile: true },
        // { text: "預估時數", value: "_" },
        { text: "實際時數", value: "_" },
        { text: "執行狀況", value: "_" },
        { text: "處理說明", value: "_" },
        { text: "獎金實發", value: "_" },
        { text: "實發月份", value: "_" },
        { text: "狀態", value: "_", showInMobile: true }
      ].concat([actionHeader]);
    },
    workLogs() {
      // const findTaskWorkingItemTask = o =>
      //   this.tasks.find(task => task.ID == o.TaskID) || {};
      const findTaskWorkingItemDepartmentID = o =>
        AppDataSetting.getTaskWorkingItemTask(this, o).DepartmentID;
      const findTaskWorkingItemProjectID = o =>
        AppDataSetting.getTaskWorkingItemTask(this, o).ProjectID;
      const findUserDepartmentID = userID =>
        (this.userDepartments.find(o => o.UserID == userID) || {})
          .DepartmentID;
      // const employeeFilter = o => o.UserID == this.me.ID;
      // const managerFilter = o =>
      //   findTaskWorkingItemDepartmentID(o) == this.myDepartment.ID;
      // const highLevelFilter = o => true;
      // var filter = employeeFilter;
      // if (this.myLevel == 10) filter = managerFilter;
      // if (this.myLevel > 10) filter = highLevelFilter;
      const normalizeDateRange = (range) => {
        if (!range || !range.length) return null;
        let start = range[0];
        let end = range.length === 1 ? range[0] : range[1];
        if (moment(start).isAfter(end)) [start, end] = [end, start];
        return [start, end];
      };
      const isInRange = (date, range) => {
        const normalized = normalizeDateRange(range);
        if (!normalized) return true;
        const [start, end] = normalized;
        return (
          (moment(start).isSame(date, "date") || moment(date).isAfter(start)) &&
          (moment(end).isSame(date, "date") || moment(date).isBefore(end))
        );
      };
      const hasDateRange = (range) => Array.isArray(range) && range.length > 0;
      var filter = o=>{
        if (this.filterCondition.ProjectID && findTaskWorkingItemProjectID(o) != this.filterCondition.ProjectID) return false;
        if (this.filterCondition.DepartmentID && findUserDepartmentID(o.UserID) != this.filterCondition.DepartmentID) return false;
        if (this.filterCondition.UserID && o.UserID != this.filterCondition.UserID) return false;
        if (hasDateRange(this.filterCondition.DateRange) && !isInRange(o.Date, this.filterCondition.DateRange)) return false;
        // if (!!(this.filterCondition.Date) && !moment(this.filterCondition.Date).isSame(o.Date, "date")) return false;
        return true
      }

      // 設置 ts 避免 moment 執行耗時
      for(let o of this.taskWorkingItems) {
        if (o.ts) continue
        o.ts = moment(moment(o.Date).format("YYYY-MM-DD"))
      }

      const sortingFunc = (o1, o2) => {
        var result = 0;
        // 依據 this.sortings 修改排序
        for (let sorting of this.sortings) {
          if (sorting.key == "date") {
            let o1TS = o1.ts//moment(moment(o1.Date).format("YYYY-MM-DD"));
            let o2TS = o2.ts//moment(moment(o2.Date).format("YYYY-MM-DD"));
            if (sorting.order == "asc") result = o1TS - o2TS;
            else result = o2TS - o1TS;
          } else if (sorting.key == "user") {
            if (sorting.order == "asc") result = o1.UserID - o2.UserID;
            else result = o2.UserID - o1.UserID;
          } else if (sorting.key == "project") {
            let o1Task = this.tasksMap[o1.TaskID] || {};
            let o2Task = this.tasksMap[o2.TaskID] || {};
            if (sorting.order == "asc") result = o1Task.ID - o2Task.ID;
            else result = o2Task.ID - o1Task.ID;
          } else {
            window.console.error(`sortingFunc, unknown key ${sorting.key}`);
          }
          if (result != 0) break;
        }
        return result;
      };

      var results = this.taskWorkingItems.filter(filter);
      if (this.sortings.length) results = results.sort(sortingFunc);
      return results;
    },
    ...mapGetters([
      "me",
      "taskWorkingItems",
      "myLevel",
      "myDepartment",
      "departments",
      "tasks",
      "tasksMap",
      "userDepartments"
    ])
  },
  methods: {
    async exportExcel() {
      const datas = this.dataTable.filter(
        o => !this.search || this.customFilter('value-whatever', this.search, o)
      );

      const fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-工作日誌-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }

      await this.runExcelExport({
        datas,
        fileName,
        buildSheetData: (items, onProgress) =>
          XMLGenerator.buildSheetData(this, items, onProgress),
      });
    },
    customFilter(value, search, item) {
      return item.Content.includes(search)
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.taskWorkingItems.indexOf(item);

      this.isLoading = true;
      this.$services.taskWorkingItem
        .delete(this, item.ID)
        .then(res => {
          this.taskWorkingItems.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除工作日誌「" + item.Content + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.workLogs;
      this.isDataRefetched = false;
      this.$store.state.taskWorkingItem.isReloaded = false;
      this.tablePage = 1
    },
    onDataUpdated(item) {
      this.reloadDataTable();
    }
  },
  created() {
    const pageName = 'worklog-list'
    window.console.log(`${pageName} created`)
    window.console.log(`${pageName} services = `, this.$services)
    window.$services = this.$services
    this.isLoading = true;
    Promise.all([
      this.$services.prepareDatas(this),
      // this.$services.prepareProjectDatas(this) // 20220501 發現 prepareDatas時就會prepareProductDatas
    ])
    .then(function(result) {
      window.console.log(`${pageName} result:`,result)
    })
    .catch(function(error) {
      window.console.error(`${pageName} error:`,error)
    })
    .finally(() => {
      window.console.log(`${pageName} finally`)
      this.reloadDataTable();
      this.isLoading = false;
    });
  },
  watch: {
    "$store.state.taskWorkingItem.isReloaded"() {
      if (
        this.$store.state.taskWorkingItem.isFetched &&
        this.$store.state.taskWorkingItem.isReloaded
      )
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>